export default __webpack_public_path__ + "algoriddim.0e0ed113.png";